exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2m2dg-iH{cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-khtml-user-select:none;-ms-touch-action:none;touch-action:none;-webkit-touch-callout:none}._2m2dg-iH::selection,._2m2dg-iH ::selection{background:transparent}._2m2dg-iH::-moz-selection,._2m2dg-iH ::-moz-selection{background:transparent}._2UOykHa4{-webkit-user-select:initial;-moz-user-select:initial;-ms-user-select:initial;user-select:auto;-khtml-user-select:initial;-webkit-touch-callout:initial}", ""]);

// exports
exports.locals = {
	"selection-scope": "_2m2dg-iH",
	"selection-scope--compat": "_2UOykHa4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/highlight/style.less
// module id = 865
// module chunks = 7